import React from "react";
import { Image } from "react-bootstrap";
import "../../assets/css/scss/component/_ImageAdvertise.scss";

export default function ImageAdvertise() {
  return (
    <div className="h-100 d-flex align-items-center flex-wrap flex-column">
      {/* theme-medium-light-gray */}
      <Image
        src="https://res.cloudinary.com/deq61wdj1/image/upload/v1755809112/lcd/advertising_banners/home_banner_yytpqu.jpg"
        className="w-100 h-50 my-auto image-border-radius-10"
        alt="leaderboard"
        fluid
      />
      {/* <div className="text-center subheading mt-auto">
                <h3 className="mb-0 theme-white bold h6">Responsive <span className="d-block">Leaderbord</span> <span className="d-block">Add Area</span></h3>
            </div> */}
    </div>
  );
}
